import * as React from 'react';
import {Block} from '../Block';
import {BlocksProps} from './types';

/**
 * The component pure render blocks of the task content.
 * @param {BlocksProps} props
 * @return {React.ReactElement<BlocksProps>}
 * @constructor
 */
export default class Blocks extends React.Component<BlocksProps> {
  /**
   * Constructor.
   * @param {BlocksProps} props
   */
  constructor(props: BlocksProps) {
    super(props);
  }

  /**
   * Render.
   * @return {JSX.Element}
   */
  render() {
    return (
      <React.Fragment>
        {this.props.blocks.map((block, index) => (
          <Block
            key={block.id}
            index={index}
            {...block}
          />
        ))}
      </React.Fragment>
    );
  }
}
